import React from "react";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import {
    PAGE_NAME,
    ROUTE,
    SOMETHING_WENT_WRONG,
    USER_REQUEST_INFO,
} from "../../../../../constants/constants";
import { Dropdown } from "../../../../atoms/dropdown";
import { Icon } from "../../../../atoms/icon";
import { Divider } from "../../../../atoms/divider";
import { AddUsersRequest } from "../../../../organisms/requestManagement/userOnboardingOffboarding/addUsers";
import {
    useApproverListQuery,
    useCreateUserRequestMutation,
} from "../../../../../store/requestManagement/requestSlice";
import { ResponseType } from "../../../../../types";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "../../../../molecules/modal";
import { RemoveLicenseRequest } from "../../../../organisms/requestManagement/assignLicenseToExistingUser/removeLicense";
import { ProjectAndTeamManagementRequest } from "../../../../organisms/requestManagement/project&TeamManagement";
import { Loader } from "../../../../atoms/loader";
import { PermissionManagementRequest } from "../../../../organisms/requestManagement/permissionManagement";
import { AssignLicenseRequest } from "../../../../organisms/requestManagement/assignLicenseToExistingUser/assignLicense";
import { SaaSToolConfigurationRequest } from "../../../../organisms/requestManagement/saasToolConfiguration";
import { RemoveUsersRequest } from "../../../../organisms/requestManagement/userOnboardingOffboarding/removeUsers";
import { InfoModal } from "../../../../molecules/infoModal";
import { RichTextEditor } from "../../../../atoms/richTextEditor";
import { CredentialsManagementRequest } from "../../../../organisms/requestManagement/credentialsManagement";
import { UserProfileUpdateRequest } from "../../../../organisms/requestManagement/userProfileUpdate";
import { useActiveUserListQuery } from "../../../../../store/user/userSlice";
import { OthersRequest } from "../../../../organisms/requestManagement/Others";

export const requestTypeOptions = [
    {
        label: "New User Onboarding & Offboarding",
        value: "New User Onboarding & Offboarding",
    },
    {
        label: "Existing User License Management",
        value: "Existing User License Management",
    },
    { label: "Project & Team Management", value: "Project & Team Management" },
    { label: "Permission Management", value: "Permission Management" },
    { label: "SaaS Tool Configuration", value: "SaaS Tool Configuration" },
    { label: "Credentials Management", value: "Credentials Management" },
    { label: "User Profile", value: "User Profile" },
    { label: "Others", value: "Others" },
];

export const subTypeOptionsUserLicense = [
    { label: "User Onboarding", value: "User Onboarding" },
    { label: "User Offboarding", value: "User Offboarding" },
];

export const subTypeOptionsAssignLicense = [
    { label: "Assign License", value: "Assign License" },
    { label: "Remove License", value: "Remove License" },
];

export const subTypeOptionsProjectTeam = [
    { label: "Project Creation", value: "Project Creation" },
    { label: "Group Creation", value: "Group Creation" },
    { label: "Space Creation", value: "Space Creation" },
    { label: "Team Creation", value: "Team Creation" },
    { label: "Dashboard Creation", value: "Dashboard Creation" },

    { label: "Project Modification", value: "Project Modification" },
    { label: "Group Modification", value: "Group Modification" },
    { label: "Space Modification", value: "Space Modification" },
    { label: "Team Modification", value: "Team Modification" },
    { label: "Dashboard Modification", value: "Dashboard Modification" },

    { label: "Project Deletion", value: "Project Deletion" },
    { label: "Group Deletion", value: "Group Deletion" },
    { label: "Space Deletion", value: "Space Deletion" },
    { label: "Team Deletion", value: "Team Deletion" },
    { label: "Dashboard Deletion", value: "Dashboard Deletion" },
];

export const subTypeOptionsPermission = [
    { label: "Assign Permission", value: "Assign Permission" },
    { label: "Modify Permission", value: "Modify Permission" },
    { label: "Remove Permission", value: "Remove Permission" },
];

export const subTypeOptionsSaaS = [
    { label: "Configuration", value: "Configuration" },
];

export const credentialsManagementOptions = [
    {
        label: "Create Credentials for Sleet",
        value: "Create Credentials for Sleet",
    },
    {
        label: "Delete Credentials for Sleet",
        value: "Delete Credentials for Sleet",
    },
];

export const subTypeUserProfileOptions = [{ label: "Update", value: "Update" }];

export const subTypeOtherOptions = [{ label: "Others", value: "Others" }];

const RequestCreate = () => {
    const pageClassName = "p-requestCreate";
    const navigate = useNavigate();
    const { state } = useLocation();

    const [isOpenInfoModal, setIsOpenInfoModal] = React.useState(false);
    const [requestInfo, setRequestInfo] = React.useState<any>(
        USER_REQUEST_INFO.DEFAULT
    );

    const [payload, setPayload] = React.useState<any>({});
    const [subTypeOptions, setSubTypeOptions] = React.useState<any>([]);
    const [isLoading, setLoading] = React.useState(false);
    const [isAddWatcher, setIsAddWatcher] = React.useState(false);

    const [isOpenErrorModal, setIsOpenErrorModal] = React.useState(false);
    const [errorMessages, setErrorMessages] = React.useState<any>([]);

    const { data: approverList } = useApproverListQuery({});
    const { data: userList, isLoading: usersLoading } = useActiveUserListQuery(
        {}
    );
    const [createAPI, { isLoading: createLoading }] =
        useCreateUserRequestMutation();

    React.useEffect(() => {
        if (state?.type && state?.subType) {
            setPayload({
                ...payload,
                requestType: {
                    value: state.type,
                    isError: false,
                    error: "",
                },
                subType: {
                    value: state.subType,
                    isError: false,
                    error: "",
                },
                user: {
                    value: {
                        label: state.user.firstName + " " + state.user.lastName,
                        value: state.user.email,
                    },
                    isError: false,
                    error: "",
                },
                first_name: {
                    value: state.user.firstName,
                    isError: false,
                    error: "",
                },
                last_name: {
                    value: state.user.lastName,
                    isError: false,
                    error: "",
                },
                email: {
                    value: state.user.email,
                    isError: false,
                    error: "",
                },
                designation: {
                    value: state.user.designation,
                    isError: false,
                    error: "",
                },
                organization: {
                    value: {
                        label: state.user?.organization?.name,
                        value: state.user?.organization?.id,
                    },
                    isError: false,
                    error: "",
                },
                department: {
                    value: { label: state?.user?.department?.department, value: state?.user?.department?.department },
                    isError: false,
                    error: "",
                },
                section: {
                    value: { label: state?.user?.section?.section, value: state?.user?.section?.section },
                    isError: false,
                    error: "",
                },
                location: {
                    value: { label: state.user.location, value: state.user.location },
                    isError: false,
                    error: "",
                },
                pic: {
                    value: {
                        label: state.user.pic.firstName + " " + state.user.pic.lastName,
                        value: state.user.pic.email,
                    },
                    isError: false,
                    error: "",
                },
                projects: {
                    value: state.user.projects?.map((project: any) => ({
                        label: project?.name,
                        value: project?.name,
                    })),
                    isError: false,
                    error: "",
                },
            });
            setSubTypeOptions(subTypeUserProfileOptions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    const requestTypeChangeHandler = (val: any) => {
        setPayload({
            requestType: {
                value: val,
                isError: false,
                error: "",
            },
            subType: {
                value: "",
                isError: false,
                error: "",
            },
        });
        if (val.value === "New User Onboarding & Offboarding") {
            setSubTypeOptions(subTypeOptionsUserLicense);
        } else if (val.value === "Existing User License Management") {
            setSubTypeOptions(subTypeOptionsAssignLicense);
        } else if (val.value === "Project & Team Management") {
            setSubTypeOptions(subTypeOptionsProjectTeam);
        } else if (val.value === "Permission Management") {
            setSubTypeOptions(subTypeOptionsPermission);
        } else if (val.value === "SaaS Tool Configuration") {
            setSubTypeOptions(subTypeOptionsSaaS);
            setPayload({
                ...payload,
                requestType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                subType: {
                    value: subTypeOptionsSaaS[0],
                    isError: false,
                    error: "",
                },
                saas_tool: {
                    value: {
                        name: "",
                        issue_summary: "",
                        instruction: "",
                    },
                    isError: false,
                    error: "",
                },
                attachments: {
                    value: undefined as File[] | undefined,
                    isError: false,
                    error: "",
                },
            });
        } else if (val.value === "Credentials Management") {
            setSubTypeOptions(credentialsManagementOptions);
        } else if (val.value === "User Profile") {
            setSubTypeOptions(subTypeUserProfileOptions);
        } else if (val.value === "Others") {
            setSubTypeOptions(subTypeOtherOptions);
            setPayload({
                ...payload,
                requestType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                subType: {
                    value: subTypeOtherOptions[0],
                    isError: false,
                    error: "",
                },
                saas_tool: {
                    value: {
                        issue_summary: "",
                        instruction: "",
                    },
                    isError: false,
                    error: "",
                },
                attachments: {
                    value: undefined as File[] | undefined,
                    isError: false,
                    error: "",
                },
            });
        }
    };

    const subTypeChangeHandler = (val: any) => {
        if (val.value === "User Onboarding") {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                users: {
                    value: [
                        {
                            first_name: "",
                            last_name: "",
                            full_name: "",
                            email: "",
                            designation: "",
                            department: "",
                            section: "",
                            address: "",
                            manager: "",
                            projects: [],
                            saas_tools: [
                                {
                                    name: {
                                        value: "Okta",
                                        label: "Okta",
                                    },
                                },
                                {
                                    name: {
                                        value: "UR&AM Tool",
                                        label: "UR&AM Tool",
                                    },
                                    role: {
                                        value: "User",
                                        label: "User",
                                    },
                                },
                            ],
                        },
                    ],
                    isError: false,
                    error: "",
                },
            });
        } else if (val.value === "User Offboarding") {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                users: [
                    {
                        label: "",
                        value: "",
                    },
                ],
            });
        } else if (val.value === "Assign License") {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                user: {
                    value: "",
                    isError: false,
                    error: "",
                },
                saas_tools: {
                    value: [
                        {
                            name: "",
                            type: "",
                            entity_name: "",
                            role: "",
                            approver: [],
                        },
                    ],
                    isError: false,
                    error: "",
                },
            });
        } else if (val.value === "Remove License") {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                users: {
                    value: [
                        {
                            email: "",
                            saas_tools: [],
                        },
                    ],
                    isError: false,
                    error: "",
                },
            });
        } else if (
            [
                "Project Creation",
                "Group Creation",
                "Space Creation",
                "Team Creation",
                "Dashboard Creation",
                "Project Deletion",
                "Group Deletion",
                "Space Deletion",
                "Team Deletion",
                "Dashboard Deletion",
            ].includes(val.value)
        ) {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                saas_tools: {
                    value: [
                        {
                            name: "",
                            entity_name: "",
                            approver: [],
                        },
                    ],
                    isError: false,
                    error: "",
                },
            });
        } else if (
            [
                "Project Modification",
                "Group Modification",
                "Space Modification",
                "Team Modification",
                "Dashboard Modification",
            ].includes(val.value)
        ) {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                saas_tools: {
                    value: [
                        {
                            name: "",
                            entity_name: "",
                            new_name: "",
                            approver: [],
                        },
                    ],
                    isError: false,
                    error: "",
                },
            });
        } else if (
            ["Assign Permission", "Modify Permission", "Remove Permission"].includes(
                val.value
            )
        ) {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                user: {
                    value: "",
                    isError: false,
                    error: "",
                },
                saas_tools: {
                    value: [
                        {
                            name: "",
                            type: "",
                            entity_name: "",
                            role: "",
                            approver: [],
                        },
                    ],
                    isError: false,
                    error: "",
                },
            });
        } else if (
            ["Create Credentials for Sleet", "Delete Credentials for Sleet"].includes(
                val.value
            )
        ) {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                user: {
                    value: "",
                    isError: false,
                    error: "",
                },
                project: {
                    value: "",
                    isError: false,
                    error: "",
                },
            });
        } else if (val.value === "Update") {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
                user: {
                    value: "",
                    isError: false,
                    error: "",
                },
                first_name: {
                    value: "",
                    isError: false,
                    error: "",
                },
                last_name: {
                    value: "",
                    isError: false,
                    error: "",
                },
                designation: {
                    value: "",
                    isError: false,
                    error: "",
                },
                department: {
                    value: "",
                    isError: false,
                    error: "",
                },
                section: {
                    value: "",
                    isError: false,
                    error: "",
                },
                location: {
                    value: "",
                    isError: false,
                    error: "",
                },
                pic: {
                    value: "",
                    isError: false,
                    error: "",
                },
                organization: {
                    value: "",
                    isError: false,
                    error: "",
                },
                projects: {
                    value: [],
                    isError: false,
                    error: "",
                },
            });
        } else {
            setPayload({
                ...payload,
                subType: {
                    value: val,
                    isError: false,
                    error: "",
                },
            });
        }
    };

    const watcherChangeHandler = (val: any) => {
        setPayload({
            ...payload,
            watchers: {
                value: val,
                isError: false,
                error: "",
            },
        });
    };

    const submitHandler = async (e: any) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append("type", payload.requestType.value.value);
        formData.append("sub_type", payload.subType.value.value);
        if (payload?.watchers?.value.length > 0) {
            payload?.watchers?.value.forEach((watcher: any) => {
                formData.append("watchers[]", watcher.value);
            });
        }
        payload?.note?.value && formData.append("notes", payload?.note?.value);
        if (payload?.subType?.value?.value === "User Onboarding") {
            formData.append("requests", JSON.stringify(payload?.users?.value));
        } else if (
            payload?.requestType?.value?.value ===
            "New User Onboarding & Offboarding" &&
            payload.subType?.value?.value === "User Offboarding"
        ) {
            formData.append("requests", JSON.stringify(payload?.users));
        } else if (payload?.subType?.value?.value === "Remove License") {
            const users = payload?.users?.value.map((user: any) => {
                return {
                    email: user.email,
                    saas_tools: user.saas_tools,
                };
            });
            formData.append("requests", JSON.stringify(users));
        } else if (
            payload?.requestType?.value?.value === "Project & Team Management" &&
            [
                "Project Creation",
                "Group Creation",
                "Space Creation",
                "Team Creation",
                "Dashboard Creation",
                "Project Modification",
                "Group Modification",
                "Space Modification",
                "Team Modification",
                "Dashboard Modification",
                "Project Deletion",
                "Group Deletion",
                "Space Deletion",
                "Team Deletion",
                "Dashboard Deletion",
            ].includes(payload.subType?.value?.value)
        ) {
            const requests = payload?.saas_tools?.value.map((element: any) => {
                delete element?.entity_name?.approver;
                return element;
            });
            formData.append("requests", JSON.stringify(requests));
        } else if (
            [
                "Assign Permission",
                "Modify Permission",
                "Remove Permission",
                "Assign License",
            ].includes(payload.subType?.value?.value)
        ) {
            const requests = {
                user: payload?.user?.value,
                saas_tools: payload?.saas_tools?.value,
            };
            formData.append("requests", JSON.stringify(requests));
        } else if (
            ["SaaS Tool Configuration", "Others"].includes(
                payload?.requestType?.value?.value
            ) &&
            ["Configuration", "Others"].includes(payload?.subType?.value?.value)
        ) {
            payload?.attachments?.value &&
                payload?.attachments?.value.forEach((file: File) => {
                    formData.append("attachments[]", file);
                });
            formData.append("requests", JSON.stringify(payload?.saas_tool?.value));
        } else if (
            payload?.requestType?.value?.value === "Credentials Management"
        ) {
            const requests = {
                user: payload?.user?.value,
                project: payload?.project?.value,
            };
            formData.append("requests", JSON.stringify(requests));
        } else if (
            payload?.requestType?.value?.value === "User Profile" &&
            payload?.subType?.value?.value === "Update"
        ) {
            const request = {
                user: payload?.user?.value,
                first_name: payload?.first_name?.value,
                last_name: payload?.last_name?.value,
                designation: payload?.designation?.value,
                department: payload?.department?.value?.value,
                section: payload?.section?.value?.value,
                projects: payload?.projects?.value,
                location: payload?.location?.value?.value,
                pic: payload?.pic?.value?.value,
                organization: payload?.organization?.value?.value,
            };
            formData.append("requests", JSON.stringify(request));
        }

        const response = (await createAPI(formData)) as ResponseType;

        if (response?.data?.success) {
            toast.success(response?.data?.message);
            navigate(ROUTE.REQUEST_HISTORY);
        } else {
            if (response?.error?.data?.errors) {
                if (
                    Array.isArray(response?.error?.data?.errors?.requests) &&
                    response?.error?.data?.errors?.requests.length > 0
                ) {
                    setErrorMessages(response?.error?.data?.errors?.requests);
                    setIsOpenErrorModal(true);
                    return;
                }

                if (response?.error?.data?.errors?.hasOwnProperty("type")) {
                    setPayload((prevState: any) => ({
                        ...prevState,
                        requestType: {
                            ...prevState.requestType,
                            error: response?.error?.data?.errors?.type[0],
                            isError: true,
                        },
                    }));
                }

                if (response?.error?.data?.errors?.hasOwnProperty("sub_type")) {
                    setPayload((prevState: any) => ({
                        ...prevState,
                        subType: {
                            ...prevState.subType,
                            error: response?.error?.data?.errors?.sub_type[0],
                            isError: true,
                        },
                    }));
                }

                if (response?.error?.data?.errors?.hasOwnProperty("notes")) {
                    setPayload((prevState: any) => ({
                        ...prevState,
                        note: {
                            ...prevState.note,
                            error: response?.error?.data?.errors?.notes[0],
                            isError: true,
                        },
                    }));
                }
            } else {
                toast.error(response?.error?.data?.message);
            }
            if (response?.error?.data?.error) {
                toast.error(SOMETHING_WENT_WRONG);
            }
        }
    };

    const infoClickHandler = () => {
        if (payload?.subType?.value?.value === "User Onboarding")
            setRequestInfo(USER_REQUEST_INFO.USER_ONBOARDING);
        else if (payload?.subType?.value?.value === "User Offboarding")
            setRequestInfo(USER_REQUEST_INFO.USER_OFFBOARDING);
        else if (payload?.subType?.value?.value === "Assign License")
            setRequestInfo(USER_REQUEST_INFO.ASSIGN_LICENSE);
        else if (payload?.subType?.value?.value === "Remove License")
            setRequestInfo(USER_REQUEST_INFO.REMOVE_LICENSE);
        else if (payload?.subType?.value?.value === "Project Creation")
            setRequestInfo(USER_REQUEST_INFO.CREATE_PROJECT);
        else if (payload?.subType?.value?.value === "Group Creation")
            setRequestInfo(USER_REQUEST_INFO.CREATE_GROUP);
        else if (payload?.subType?.value?.value === "Space Creation")
            setRequestInfo(USER_REQUEST_INFO.CREATE_SPACE);
        else if (payload?.subType?.value?.value === "Team Creation")
            setRequestInfo(USER_REQUEST_INFO.CREATE_TEAM);
        else if (payload?.subType?.value?.value === "Dashboard Creation")
            setRequestInfo(USER_REQUEST_INFO.CREATE_DASHBOARD);
        else if (payload?.subType?.value?.value === "Project Modification")
            setRequestInfo(USER_REQUEST_INFO.MODIFY_PROJECT);
        else if (payload?.subType?.value?.value === "Group Modification")
            setRequestInfo(USER_REQUEST_INFO.MODIFY_GROUP);
        else if (payload?.subType?.value?.value === "Space Modification")
            setRequestInfo(USER_REQUEST_INFO.MODIFY_SPACE);
        else if (payload?.subType?.value?.value === "Team Modification")
            setRequestInfo(USER_REQUEST_INFO.MODIFY_TEAM);
        else if (payload?.subType?.value?.value === "Dashboard Modification")
            setRequestInfo(USER_REQUEST_INFO.MODIFY_DASHBOARD);
        else if (payload?.subType?.value?.value === "Project Deletion")
            setRequestInfo(USER_REQUEST_INFO.DELETE_PROJECT);
        else if (payload?.subType?.value?.value === "Group Deletion")
            setRequestInfo(USER_REQUEST_INFO.DELETE_GROUP);
        else if (payload?.subType?.value?.value === "Space Deletion")
            setRequestInfo(USER_REQUEST_INFO.DELETE_SPACE);
        else if (payload?.subType?.value?.value === "Team Deletion")
            setRequestInfo(USER_REQUEST_INFO.DELETE_TEAM);
        else if (payload?.subType?.value?.value === "Dashboard Deletion")
            setRequestInfo(USER_REQUEST_INFO.DELETE_DASHBOARD);
        else if (payload?.subType?.value?.value === "Assign Permission")
            setRequestInfo(USER_REQUEST_INFO.ASSIGN_PERMISSION);
        else if (payload?.subType?.value?.value === "Modify Permission")
            setRequestInfo(USER_REQUEST_INFO.MODIFY_PERMISSION);
        else if (payload?.subType?.value?.value === "Remove Permission")
            setRequestInfo(USER_REQUEST_INFO.REMOVE_PERMISSION);
        else if (payload?.subType?.value?.value === "Configuration")
            setRequestInfo(USER_REQUEST_INFO.CONFIGURATION);
        else if (payload?.subType?.value?.value === "Create Credentials for Sleet")
            setRequestInfo(USER_REQUEST_INFO.CREATE_CREDENTIALS_FOR_SLEET);
        else if (payload?.subType?.value?.value === "Delete Credentials for Sleet")
            setRequestInfo(USER_REQUEST_INFO.DELETE_CREDENTIALS_FOR_SLEET);
        else if (payload?.subType?.value?.value === "Update")
            setRequestInfo(USER_REQUEST_INFO.USER_PROFILE_UPDATE);
        else if (payload?.subType?.value?.value === "Others")
            setRequestInfo(USER_REQUEST_INFO.OTHERS);

        setIsOpenInfoModal(true);
    };

    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>{PAGE_NAME.REQUEST_CREATE}</p>
            <div className={`${pageClassName}__container`}>
                <Loader isLoading={createLoading || isLoading || usersLoading}>
                    <form className={`${pageClassName}__form`} onSubmit={submitHandler}>
                        <div className={`${pageClassName}__form__items`}>
                            <div className={`${pageClassName}__form__item`}>
                                <label className={`${pageClassName}__form__item__label`}>
                                    Request Type
                                </label>
                                <Dropdown
                                    options={requestTypeOptions}
                                    selected={payload?.requestType?.value}
                                    placeholder="Please select request type"
                                    onClickChange={requestTypeChangeHandler}
                                    className={`${pageClassName}__form__item__dropdown`}
                                    isRequired
                                    isError={payload?.requestType?.isError}
                                    error={payload?.requestType?.error}
                                />
                            </div>
                            <div className={`${pageClassName}__form__item`}>
                                <label className={`${pageClassName}__form__item__label`}>
                                    Sub Type
                                </label>
                                <div className={`${pageClassName}__form__item__subType`}>
                                    <Dropdown
                                        className={`${pageClassName}__form__item__dropdown`}
                                        options={subTypeOptions}
                                        selected={payload?.subType?.value}
                                        placeholder="Please select request sub type"
                                        onClickChange={subTypeChangeHandler}
                                        isDisabled={
                                            payload?.subType?.value?.value === "Configuration"
                                                ? true
                                                : false
                                        }
                                        isRequired
                                    />
                                    <button
                                        type="button"
                                        className={`${pageClassName}__form__infoButton`}
                                        onClick={() => infoClickHandler()}
                                    >
                                        <Icon icon="information" size="primary" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className={`${pageClassName}__form__item`}>
                            <button
                                type="button"
                                className={`${pageClassName}__form__addWatcherButton`}
                                onClick={() => {
                                    setIsAddWatcher(!isAddWatcher);
                                    if (!isAddWatcher) {
                                        setPayload({
                                            ...payload,
                                            watchers: {
                                                value: [],
                                                isError: false,
                                                error: "",
                                            },
                                        });
                                    }
                                }}
                            >
                                <Icon icon={isAddWatcher ? "minus" : "plus"} size="secondary" />
                                {isAddWatcher ? "Remove Watchers" : "Add Watchers"}
                            </button>
                            {isAddWatcher && (
                                <div className={`${pageClassName}__form__item`}>
                                    <label className={`${pageClassName}__form__item__label`}>
                                        Watchers
                                    </label>
                                    <Dropdown
                                        className={`${pageClassName}__form__item__dropdown`}
                                        options={userList?.result?.data?.map((user: any) => {
                                            return {
                                                label: user.firstName + " " + user.lastName,
                                                value: user.id,
                                            };
                                        })}
                                        isMulti
                                        selected={payload?.watchers?.value}
                                        placeholder="Please select watchers"
                                        onClickChange={watcherChangeHandler}
                                    />
                                </div>
                            )}
                        </div>
                        <Divider />

                        {payload?.requestType?.value?.value ===
                            "New User Onboarding & Offboarding" &&
                            payload.subType?.value?.value === "User Onboarding" && (
                                <AddUsersRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    approverList={approverList}
                                    setLoading={setLoading}
                                />
                            )}

                        {payload?.requestType?.value?.value ===
                            "New User Onboarding & Offboarding" &&
                            payload.subType?.value?.value === "User Offboarding" && (
                                <RemoveUsersRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    approverList={approverList}
                                    setLoading={setLoading}
                                />
                            )}

                        {payload?.requestType?.value?.value ===
                            "Project & Team Management" &&
                            [
                                "Project Creation",
                                "Group Creation",
                                "Space Creation",
                                "Team Creation",
                                "Dashboard Creation",
                                "Project Modification",
                                "Group Modification",
                                "Space Modification",
                                "Team Modification",
                                "Dashboard Modification",
                                "Project Deletion",
                                "Group Deletion",
                                "Space Deletion",
                                "Team Deletion",
                                "Dashboard Deletion",
                            ].includes(payload.subType?.value?.value) && (
                                <ProjectAndTeamManagementRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    approverList={approverList}
                                />
                            )}

                        {payload?.requestType?.value?.value === "Permission Management" &&
                            [
                                "Assign Permission",
                                "Modify Permission",
                                "Remove Permission",
                            ].includes(payload.subType?.value?.value) && (
                                <PermissionManagementRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    approverList={approverList}
                                    setLoading={setLoading}
                                />
                            )}

                        {payload?.requestType?.value?.value ===
                            "Existing User License Management" &&
                            payload.subType?.value?.value === "Assign License" && (
                                <AssignLicenseRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    approverList={approverList}
                                    setLoading={setLoading}
                                />
                            )}

                        {payload?.requestType?.value?.value ===
                            "Existing User License Management" &&
                            payload.subType?.value?.value === "Remove License" && (
                                <RemoveLicenseRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    approverList={approverList}
                                    setLoading={setLoading}
                                />
                            )}

                        {payload?.requestType?.value?.value === "SaaS Tool Configuration" &&
                            payload.subType?.value?.value === "Configuration" && (
                                <SaaSToolConfigurationRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                />
                            )}

                        {payload?.requestType?.value?.value === "Others" &&
                            payload.subType?.value?.value === "Others" && (
                                <OthersRequest payload={payload} setPayload={setPayload} />
                            )}

                        {payload?.requestType?.value?.value === "Credentials Management" &&
                            [
                                "Create Credentials for Sleet",
                                "Delete Credentials for Sleet",
                            ].includes(payload.subType?.value?.value) && (
                                <CredentialsManagementRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    setLoading={setLoading}
                                />
                            )}
                        {payload?.requestType?.value?.value === "User Profile" &&
                            payload.subType?.value?.value === "Update" && (
                                <UserProfileUpdateRequest
                                    payload={payload}
                                    setPayload={setPayload}
                                    setLoading={setLoading}
                                />
                            )}

                        <RichTextEditor
                            label="Notes"
                            placeholder="Please type your notes"
                            value={payload?.note?.value}
                            isError={payload?.note?.isError}
                            error={payload?.note?.error}
                            onChanged={(value) =>
                                setPayload({
                                    ...payload,
                                    note: {
                                        value: value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                        />

                        <div className={`${pageClassName}__form__action`}>
                            <button
                                type="submit"
                                className={`${pageClassName}__form__action__button`}
                                disabled={createLoading || isLoading}
                            >
                                Submit
                            </button>

                            <button
                                type="button"
                                className={`${pageClassName}__form__action__button ${pageClassName}__form__action--cancel`}
                                onClick={() => navigate(ROUTE.REQUEST_HISTORY)}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Loader>
            </div>

            <Modal
                isOpen={isOpenErrorModal}
                header="Error Message"
                width="small"
                headerColor="error"
                onClose={() => setIsOpenErrorModal(!isOpenErrorModal)}
                className={`${pageClassName}__modal`}
            >
                <div className={`${pageClassName}__modal__body`}>
                    <p className={`${pageClassName}__modal__body__message`}>
                        We found {errorMessages.length} error
                        {errorMessages.length > 1 ? "s" : ""} in your request. Please
                        correct them and try again.
                    </p>
                    {errorMessages.map((element: string, index: number) => {
                        return (
                            <div key={element} className={`${pageClassName}__modal__error`}>
                                <p className={`${pageClassName}__modal__error__serial`}>
                                    {index + 1}.
                                </p>
                                <p className={`${pageClassName}__modal__error__message`}>
                                    {element}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </Modal>

            <InfoModal
                isOpen={isOpenInfoModal}
                header="Information"
                onClose={() => setIsOpenInfoModal(!isOpenInfoModal)}
                className={`${pageClassName}__modal`}
            >
                <p dangerouslySetInnerHTML={{ __html: requestInfo }} />
            </InfoModal>
        </div>
    );
};

export default RequestCreate;
